
import { SignalRReceiveEvent, SignalRSendEvent } from "../../Component/Model/Enum/SignalREvents";
import { SignalRHubs } from "../../Component/Model/Enum/SignalRHubs";
import { BaseClient } from "../BaseSignalRClient";


export class UploadFileProgressClient extends BaseClient {
    constructor() {

        super()
    }

    joinGroup = (username: string, updateStatusCallBack: any) => {
        this.sendPayload(SignalRSendEvent.JoinGroup, username, SignalRHubs.UploadFileProgessHub, updateStatusCallBack);
    }

    removeListeners = (updateStatusCallBack: any) => {
        this.removeListener(SignalRReceiveEvent.UpdateStatus, updateStatusCallBack);
    };

}